import { createContext } from "react";

export type FormMeta = {
    formType: string;
    formName: string;
    pageNumber: number;
};

export const FormMetaContext = createContext<FormMeta>({ formType: "", formName: "", pageNumber: 0 });
